import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {PropType, ref} from "vue";
import {ColoredSelectionGroupOptionData} from "@/lib/components/form/selection/type/ColoredSelectionGroupOptionsData";
import SelectionGroup from "@/lib/components/form/selection/SelectionGroup.vue";
import AutoColorPicker from "@/lib/components/form/color/AutoColorPicker.vue";
import {defaultSuggestedColors} from "@/lib/components/form/selection/color/DefaultSuggestedColors";


export default /*#__PURE__*/_defineComponent({
  name: 'ColoredSelectionGroup',
  props: {
  suggestedColors: {
    type: Array as PropType<String[]>,
    default: defaultSuggestedColors
  },
  options: {
    type: Array as PropType<ColoredSelectionGroupOptionData[]>,
    required: true,
  },
  selectedOptionsIds: {
    type: Array as PropType<(String|Number)[]>,
    required: true,
  },
  canOptionsBeDeleted: {
    type: Boolean,
    default: false,
  },
  canAddNewOptions: {
    type: Boolean,
    default: false,
  },
  addNewOptionPlaceholder: {
    type: String,
    default: "Option name",
  },
  optionIdHolder: String
},
  emits: ['addColoredOption'],
  setup(__props, { emit }) {

const props = __props




const getSelectionBodySlotName = (optionId: string) => {
  return "selection-body-" + optionId;
}

const currentPickedColor = ref(),
    switchToNextSuggestedColor = ref(0);

const onColorPicked = (color: string) => {
  currentPickedColor.value = color;
}



const onAddOption = (newOptionValue: string) =>
{
  emit("addColoredOption", {
    value: newOptionValue,
    colorCode: currentPickedColor.value
  });

  switchToNextSuggestedColor.value++; // switches to the next suggested color to save time
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectionGroup, {
    options: __props.options,
    "selected-options-ids": __props.selectedOptionsIds,
    "add-new-option-placeholder": __props.addNewOptionPlaceholder,
    "can-add-new-options": __props.canAddNewOptions,
    "can-options-be-deleted": __props.canOptionsBeDeleted,
    "option-id-holder": __props.optionIdHolder,
    onAddOption: onAddOption
  }, _createSlots({
    selectionBody: _withCtx(({ option }: {option: ColoredSelectionGroupOptionData}) => [
      _createElementVNode("div", {
        class: "option-color",
        style: _normalizeStyle('background-color:' + option.colorCode + ';')
      }, null, 4)
    ]),
    "add-selection": _withCtx(() => [
      _createVNode(AutoColorPicker, {
        suggestedColors: __props.suggestedColors,
        switchToNextSuggestedColor: switchToNextSuggestedColor.value,
        onOnColorPicked: onColorPicked
      }, null, 8, ["suggestedColors", "switchToNextSuggestedColor"])
    ]),
    additionalOptionActions: _withCtx(({ option }: {option: ColoredSelectionGroupOptionData}) => [
      _renderSlot(_ctx.$slots, "additionalOptionActions", { option: option })
    ]),
    _: 2
  }, [
    _renderList(props.options, (option, id) => {
      return {
        name: getSelectionBodySlotName(id),
        fn: _withCtx(() => [])
      }
    })
  ]), 1032, ["options", "selected-options-ids", "add-new-option-placeholder", "can-add-new-options", "can-options-be-deleted", "option-id-holder"]))
}
}

})